import DHCP from '@appblocks/codegeneration/Libraries/DHCP';
import Sock from '@appblocks/codegeneration/Libraries/Sock';
import Wln from '@appblocks/codegeneration/Libraries/Wln';
import Time from '@appblocks/codegeneration/Libraries/Time';
import Filenum from '@appblocks/codegeneration/Libraries/Filenum';
import Stg from '@appblocks/codegeneration/Libraries/Stg';
import Log from '@appblocks/codegeneration/Libraries/Log';
import Tbl from '@appblocks/codegeneration/Libraries/Tbl';
import MQTT from '@appblocks/codegeneration/Libraries/MQTT';
import SNTP from '@appblocks/codegeneration/Libraries/SNTP';
import DNS from '@appblocks/codegeneration/Libraries/DNS';
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import LUIS from '@appblocks/codegeneration/Libraries/LUIS';
import LCDMenu from '@appblocks/codegeneration/Libraries/LCDMenu';
import DSMAN from '@appblocks/codegeneration/Libraries/DSMAN';
import Modbus from '@appblocks/codegeneration/Libraries/Modbus';
import HTTP from '@appblocks/codegeneration/Libraries/HTTP';
import Cgg from '@appblocks/codegeneration/Libraries/Cgg';
import LCDGraph from '@appblocks/codegeneration/Libraries/LCDGraph';
import DateTime from '@appblocks/codegeneration/Libraries/DateTime';
import Azure from '@appblocks/codegeneration/Libraries/Azure';
import AzureTelemetry from '@appblocks/codegeneration/Libraries/AzureTelemetry';
import AzureProperty from '@appblocks/codegeneration/Libraries/AzureProperty';
import CggTelemetry from '@appblocks/codegeneration/Libraries/CggTelemetry';
import AzureCommand from '@appblocks/codegeneration/Libraries/AzureCommand';
import Cron from '@appblocks/codegeneration/Libraries/Cron';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import ModbusMaster from '@appblocks/codegeneration/Libraries/ModbusMaster';
import ModbusSlave from '@appblocks/codegeneration/Libraries/ModbusSlave';
import SNMP from '@appblocks/codegeneration/Libraries/SNMP';
import MQTTLib from '@appblocks/codegeneration/Libraries/MQTTLib';
import DisplayLib from '@appblocks/codegeneration/Libraries/DisplayLib';
import StgcmdLib from '@appblocks/codegeneration/Libraries/StgcmdLib';
import MbedTLS from '@appblocks/codegeneration/Libraries/MbedTLS';

const LibrariesMap: { [featureId: string]: any } = {
    wln: Wln,
    dhcp: DHCP,
    sock: Sock,
    time: Time,
    filenum: Filenum,
    stg: Stg,
    log: Log,
    tbl: {
        tios: Tbl,
        ntios: undefined,
        arduino: undefined,
        simulator: Tbl,
    },
    mqtt: MQTT,
    mqtt_lib: MQTTLib,
    azure: Azure,
    sntp: SNTP,
    dns: DNS,
    luis: LUIS,
    lcd_menu: LCDMenu,
    ds_man: DSMAN,
    modbus: Modbus,
    modbus_master: ModbusMaster,
    modbus_slave: ModbusSlave,
    http: HTTP,
    cgg: Cgg,
    lcd_graph: LCDGraph,
    datetime: DateTime,
    azure_telemetry: AzureTelemetry,
    azure_property: AzureProperty,
    cgg_telemetry: CggTelemetry,
    azure_command: AzureCommand,
    cron: Cron,
    snmp: SNMP,
    display_lib: DisplayLib,
    stgcmd_lib: StgcmdLib,
    mbedtls: MbedTLS,
};

export default class Libraries {
    static getItem(itemId: string, project: ProjectConfiguration) {
        try {
            if (LibrariesMap[itemId] !== undefined) {
                if (project.runtime
                    && LibrariesMap[itemId][project.runtime] !== undefined) {
                    return new LibrariesMap[itemId][project.runtime]();
                }
                return new LibrariesMap[itemId]();
            }
        } catch (e) {
            return undefined;
        }
        return undefined;
    }

    static getList() {
        return Object.keys(LibrariesMap);
    }
}
